import {Box} from "@mui/system"
import {Typography} from "@mui/material"
import theme from "../../theme/theme"
import React from "react"
import PropTypes from "prop-types"

const InfoItem = ({ label, value }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
                variant="contraHeading"
                sx={{ color: theme.palette.primary.white70 }}
            >
                {label}
            </Typography>
            <Typography variant="textBody" color="common.white">
                {value}
            </Typography>
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
}

export default InfoItem